<div class="p-4 text-white">
  <div class="flex justify-between">
    <p class="font-bold text-2xl">Exportar cronograma de clases</p>
    <ion-icon class="text-2xl cursor-pointer" name="close-outline" (click)="modalController.dismiss()"></ion-icon>
  </div>
  <div class="my-8 px-2">
    <p>¡Agrega el siguiente codigo Iframe a tu sitio web para mostrar directamente tu calendario de clases¡</p>
    <p>Cualquier persona podra consultarlo y los atletas registrados podran agendar directamente haciendo uso de su membresía</p>
  </div>

  <div class="flex justify-end gap-4 text-2xl">
    <ion-icon [matTooltip]="'copiar url'" name="link-outline" (click)="copyUrl()"></ion-icon>
    <ion-icon [matTooltip]="'cambiar tema'" [name]="theme == 'dark'?'sunny-outline':'moon-outline'" (click)="changeTheme()"></ion-icon>
    <ion-icon [matTooltip]="'copiar codigo iframe'" name="copy-outline" (click)="copyIframe()"></ion-icon>
  </div>
  <div class="py-2 px-8 my-4 bg-jet-black-800 rounded-md">
    {{iframeData}}
  </div>
  <div id="iframe-container"></div>
  
</div>